import React from "react";

const Aboutus = () => {
  return (
    <>
      <div className="lg:px-36 md:py-5 px-5">
        <div className="container mx-auto">
          <div className="-mx-4 flex flex-wrap items-center justify-between">
            <div className="w-full lg:w-6/12">
              <div className="-mx-3 flex items-center sm:-mx-4">
                <div className="w-full px-3 sm:px-4 xl:w-1/2">
                  <div className="py-3 sm:py-4">
                    <img
                      src="https://blog.dookinternational.com/images/post-media/ulQFe1712299016.jpg"
                      alt=""
                      loading="lazy"
                      className="w-full rounded-2xl"
                    />
                  </div>
                  <div className="py-3 sm:py-4">
                    <img
                      src="https://www.holidify.com/images/bgImages/MILAN.jpg"
                      alt=""
                      loading="lazy"
                      className="w-full rounded-2xl"
                    />
                  </div>
                </div>
                <div className="w-full px-3 sm:px-4 xl:w-1/2">
                  <div className="relative z-10 my-4">
                    <img
                      src="https://www.flamingotravels.co.in/blog/wp-content/uploads/2022/04/Main_image2.jpg"
                      alt=""
                      loading="lazy"
                      className="w-full rounded-2xl"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full px-4 lg:w-1/2 xl:w-5/12">
  <div className="mt-10 lg:mt-0">
    {/* <span className="text-[#41A4FF] mb-2 block text-lg font-semibold">
      Why Choose Us
    </span> */}
    <h2 className="text-dark mb-8 text-3xl font-bold sm:text-4xl">
      Stress-free tour and travel package bookings made simple.
    </h2>
    <p className="text-body-color mb-8 text-base">
      We simplify your travel planning with easy, reliable bookings for curated tours and travel packages.
    </p>
    <p className="text-body-color mb-12 text-base">
      Partnered with trusted tour operators, we offer the best deals and dedicated support to make your journey smooth and unforgettable.
    </p>
  </div>
</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Aboutus;
